import { RouteGuard } from '@/shared/interfaces/route-guard'
import { Injector } from '@/config/dependency-injection'
import { AuthenticationService } from '@/authentication/authentication-service'
import { NotificationService } from '@/shared/services/notification-service'

export const authenticationGuard: RouteGuard = (to, from, next) => {
  const authenticationService = Injector.get(AuthenticationService)

  authenticationService.ensureAuthenticationIsValid({ goHome: false })

  if (to.meta?.auth) {
    // User has to be authenticated
    const hasRoles = authenticationService.hasRoles(to.meta.auth.roles)

    if (hasRoles) {
      next()
    } else {
      try {
        const notificationService = Injector.get(NotificationService)

        notificationService.showError('routes.auth.forbidden')

        next(false)
      } catch (e) {
        // If the notificationService cannot be resolved then we have not yet created the application
        // instance. Which means that the authentication guard ran for the first navigation and checks
        // the authentication. If the user is not authenticated or does not have the necessary
        // role, then we just go to home.

        next({
          name: 'home',
        })
      }
    }
  } else {
    next()
  }
}
